<template>
  <div id="header">
    <div class="header view view-slideup on">
      <div class="content-event">
        <div class="decor1"></div>
        <div class="decor2"></div>
        <span class="lantern1"></span>
        <span class="lantern2"></span>
      </div>
      <div class="com-top">
        <div class="top-left">
          <div class="partners">
            <!-- 语言选择 -->

            <a href="javascript:void(0);" class="p-logo">
              <div id="language">
                <span :class="`${$i18n.locale == 'zh' || $i18n.locale == 'tw' ? 'zh-CN' : ''}${$i18n.locale == 'en' ? 'en-US' : ''}`">
                  {{ $i18n.locale == 'zh' ? '简体中文' : '' }}
                  {{ $i18n.locale == 'tw' ? '繁體中文' : '' }}
                  {{ $i18n.locale == 'en' ? 'English' : '' }}
                  <i class="fa fa-caret-down"></i
                ></span>

                <ul id="select-language" style="height: 99px; padding-top: 0px; margin-top: 0px; padding-bottom: 0px; margin-bottom: 0px; overflow: hidden">
                  <li class="ng-scope" @click="changLang('zh')">
                    <span class="zh-CN">简体中文</span>
                  </li>
                   <li class="ng-scope" @click="changLang('tw')">
                    <span class="zh-CN">繁體中文</span>
                  </li>
                  <li class="ng-scope" @click="changLang('en')">
                    <span class="en-US">English</span>
                  </li>
                </ul>
              </div>
            </a>
            <a href="javascript:void(0);" class="p-logo p-logo2">
              <div class="p-text">
                <p class="txt1">
                  <font style="vertical-align: inherit"
                    ><font style="vertical-align: inherit">{{ $store.state.appInfo.title }}</font></font
                  >
                </p>
                <p style="font-size: 14px">
                  <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.specialized') }}</font></font>
                </p>
              </div>
            </a>
            <a href="javascript:void(0);" class="p-logo2 p-logo4">
              <div class="p-text">
                <p class="txt1">
                  <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.Entitybrand') }} </font></font>
                </p>
                <p style="font-size: 14px">
                  <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.onlinebrand') }} </font></font>
                </p>
              </div>
            </a>
          </div>
        </div>

        <div class="top-right">
          <div class="user-login" v-if="!$store.state.token">
            <span class="pz" @click="$parent.getAgentLoginUrl"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.Proxylogin') }}&nbsp;&nbsp;</font></font></span
            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">| </font></font
            ><span class="pz license"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.Regularlicense') }}&nbsp;&nbsp;</font></font></span
            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">| </font></font
            ><span class="sc" @click="$parent.showTost(0, $t('header.nohaveTost'))"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.borrow') }}&nbsp;&nbsp;</font></font></span
            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">| </font></font
            ><span class="sc" @click="$parent.showTost(0, $t('header.nohaveTost'))"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.YueBao') }} </font></font></span
            >

            <a class="shiwan" href="javascript:void(0);" @click="$parent.goNav('/login')"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.Login') }}</font></font></a
            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">| </font></font
            ><a class="shiwan1" @click="$parent.goNav('/register')"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.register') }}</font></font></a
            >
          </div>
          <div class="user-login" v-else>
            <span class="pz" @click="$parent.getAgentLoginUrl"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.Proxylogin') }}&nbsp;&nbsp;</font></font></span
            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">| </font></font
            ><span class="pz license"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.Regularlicense') }}&nbsp;&nbsp;</font></font></span
            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">| </font></font
            ><span class="sc" @click="$parent.showTost(0, $t('header.nohaveTost'))"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.borrow') }}&nbsp;&nbsp;</font></font></span
            ><font style="vertical-align: inherit"><font style="vertical-align: inherit">| </font></font
            ><span class="sc" @click="$parent.showTost(0, $t('header.nohaveTost'))"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.YueBao') }} </font></font></span
            >

            <a class="shiwan" @click="$parent.goNav('/transfer')"
              ><font style="vertical-align: inherit"
                ><font style="vertical-align: inherit">{{ $store.state.userInfo.username ? $store.state.userInfo.username : '' }} </font></font
              ></a
            ><font style="vertical-align: inherit"
              ><font style="vertical-align: inherit"> | </font><font style="vertical-align: inherit">¥{{ $store.state.userInfo.balance }} | </font></font
            ><a @click="outLogin"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.Signout') }}</font></font></a
            >
          </div>
        </div>
      </div>
    </div>

    <div class="navigation">
      <div class="inner view view-slideup on">
        <ul class="nav" id="meyNav">
          <li class="first selected" id="menu_01">
            <a @click="$parent.goNav('/')"
              ><font style="vertical-align: inherit"
                ><font style="vertical-align: inherit"
                  >{{ $t('header.home') }}
                  <!-- {{ $t('login.title') }} -->
                </font></font
              >
              <span class="pc-remark">HOME</span>
            </a>
            <span class="dot-line"></span>
          </li>
          <li id="menu_qp">
            <a @click="$parent.goNav('/joker')"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.boardgame') }}</font></font>
              <span class="pc-remark">CARD GAME</span>
            </a>
            <span class="new common-icons"></span>
            <span class="dot-line"></span>
            <ol class="subnav">
              <li :game-box="item.platform_name" v-for="(item, index) in jokerList" :key="index" v-if="item.app_state == 1" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"></li>
            </ol>
          </li>
          <li id="menu_04">
            <a @click="$parent.goNav('/concise')"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.electronicgames') }}</font></font>
              <span class="pc-remark">SLOTS</span>
            </a>
            <span class="new common-icons"></span>
            <span class="dot-line"></span>
            <ol class="subnav">
              <li :game-box="item.platform_name" v-for="(item, index) in conciseList" :key="index" v-if="item.app_state == 1 && item.platform_name != 'pg'" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"></li>
            </ol>
          </li>
          <li id="menu_03">
            <a @click="$parent.goNav('/realbet')"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.livevideo') }}</font></font>
              <span class="pc-remark">CASINO</span>
            </a>
            <ol class="subnav">
              <li :game-box="item.platform_name" v-for="(item, index) in realbetList" :key="index" v-if="item.app_state == 1" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"></li>
            </ol>
          </li>
          <li style="width: 150px">
            <a href="javascript:void(0);"></a>
            <img :src="$store.state.appInfo.site_logo || '/static/image/logo.png'" onerror="this.src = '/static/image/logo.png'" class="bounce-logo" @click="$parent.goNav('/')" style="top: -60px; width: 135px; left: 7.5px" />
          </li>
          <li>
            <a @click="$parent.goNav('/gaming')"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.eSportsbattle') }}</font></font>
              <span class="pc-remark">ESPORT GAME</span>
            </a>
            <span class="new common-icons"></span>
            <span class="dot-line"></span>
            <ol class="subnav">
              <li :game-box="item.platform_name" v-for="(item, index) in gamingList" :key="index" v-if="item.app_state == 1" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"></li>
            </ol>
          </li>
          <li id="menu_05">
            <a @click="$parent.goNav('/lottery')"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.lotterybetting') }}</font></font>
              <span class="pc-remark">LOTTERY</span>
            </a>
            <span class="dot-line"></span>
            <ol class="subnav">
              <li :game-box="item.platform_name == 'ig' ? item.game_code : item.platform_name" v-for="(item, index) in lotteryList" :key="index" v-if="item.app_state == 1" @click="$parent.openGamePage(item.platform_name, item.game_code, '')">
                <!-- <span style="color: #000">{{ item.name }}</span> -->
              </li>
            </ol>
          </li>
          <li id="menu_02">
            <a @click="$parent.goNav('/sport')"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.sportingevents') }}</font></font>
              <span class="pc-remark">SPORTS</span>
            </a>
            <span class="dot-line"></span>
            <ol class="subnav">
              <li :game-box="item.platform_name" v-for="(item, index) in sportList" :key="index" v-if="item.app_state == 1" @click="$parent.openGamePage(item.platform_name, item.game_code, '')"></li>
            </ol>
          </li>

          <li class="last" id="menu_06">
            <a @click="$parent.goNav('/activity')" target="_blank"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('header.Promotions') }}</font></font>
              <span class="pc-remark">PROMOTIONS</span>
            </a>
            <span class="new common-icons" style="right: -21px"></span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  data() {
    return { baseURL: '', bfNum: 0, vipLis: [], realbetList: [], jokerList: [], gamingList: [], sportList: [], lotteryList: [], conciseList: [] };
  },
  created() {
    let that = this;
    that.baseURL = sessionStorage.getItem('baseURL') || '';
    that.getGameList();

    // that.uservip();
  },
  methods: {
    changLang(lang) {
      let that = this;
      if (that.$i18n.locale == lang) {
        return;
      }
      that.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
      this.$router.go(0);
    },
    getGameList() {
      let that = this;

      that.$apiFun.get('/api/game/list', { category: '' }).then(res => {
        if (res.code == 200) {
          let list = res.data;
          // that[name] = res.data;
          list.forEach(el => {
            if (el.category_id == 'realbet') {
              that.realbetList.push(el);
            }
            if (el.category_id == 'joker') {
              that.jokerList.push(el);
            }
            if (el.category_id == 'gaming') {
              that.gamingList.push(el);
            }
            if (el.category_id == 'sport') {
              that.sportList.push(el);
            }
            if (el.category_id == 'lottery') {
              that.lotteryList.push(el);
            }
            if (el.category_id == 'concise') {
              that.conciseList.push(el);
            }
          });
        }
      });
    },
    outLogin() {
      let that = this;
      that.$parent.outLogin();
    },
    changPath(path) {
      let _this = null;
      //首頁
      if (path == '/') {
        //  let _this = $('.wallet_tranfers').children().eq(e); //当前点击元素
        _this = $('#meyNav').children().eq(0);
      }
      //棋牌游戏
      if (path == '/joker') {
        _this = $('#meyNav').children().eq(1);
      }
      //电子游艺
      if (path == '/concise') {
        _this = $('#meyNav').children().eq(2);
      }
      //真人视讯
      if (path == '/realbet') {
        _this = $('#meyNav').children().eq(3);
      }
      //电竞游戏
      if (path == '/gaming') {
        _this = $('#meyNav').children().eq(5);
      }
      //彩票投注
      if (path == '/lottery') {
        _this = $('#meyNav').children().eq(6);
      }
      //体育赛事
      if (path == '/sport') {
        _this = $('#meyNav').children().eq(7);
      }

      if (_this != null) {
        _this.siblings().removeClass('selected');
        _this.addClass('selected');
      } else {
        $('#meyNav').children().eq(0).siblings().removeClass('selected');
        $('#meyNav').children().eq(1).siblings().removeClass('selected');
      }
    },
  },
  updated() {
    let that = this;
    that.changPath(that.$route.path);
  },
  mounted() {
    let that = this;
    $('#language').hover(
      function () {
        $(this).children('#select-language').show();
        console.log(123);
      },
      function () {
        $(this).children('#select-language').hide();
      },
    );
  },
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.changPath(that.$route.path);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/chunk-b7675268.a1b3941c.css';
</style>



// WEBPACK FOOTER //
// src/components/libs/Header.vue